function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M226.809 42.4717H30.302C27.264 42.4717 24.802 44.9347 24.802 47.9717C24.802 51.0087 27.264 53.4717 30.302 53.4717H49.995V222.549C49.995 233.853 59.191 243.049 70.495 243.049H186.616C197.92 243.049 207.116 233.853 207.116 222.549V53.4717H226.809C229.847 53.4717 232.309 51.0087 232.309 47.9717C232.309 44.9347 229.846 42.4717 226.809 42.4717ZM196.116 222.549C196.116 227.787 191.854 232.049 186.616 232.049H70.495C65.257 232.049 60.995 227.787 60.995 222.549V53.4717H196.116V222.549Z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M95.468 24.0488H167.373C170.411 24.0488 172.873 21.5858 172.873 18.5488C172.873 15.5118 170.411 13.0488 167.373 13.0488H95.468C92.43 13.0488 89.968 15.5118 89.968 18.5488C89.968 21.5858 92.431 24.0488 95.468 24.0488Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M103.129 174.133C106.167 174.133 108.629 171.67 108.629 168.633V101.188C108.629 98.1514 106.167 95.6885 103.129 95.6885C100.091 95.6885 97.6289 98.1514 97.6289 101.188V168.633C97.6289 171.67 100.091 174.133 103.129 174.133Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M154.969 174.133C158.007 174.133 160.469 171.67 160.469 168.633V101.188C160.469 98.1514 158.007 95.6885 154.969 95.6885C151.931 95.6885 149.469 98.1514 149.469 101.188V168.633C149.469 171.67 151.931 174.133 154.969 174.133Z",
  fill: "currentColor"
});

function SvgIconTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.8c4b6c962237e86640123cbd47159c1e.svg";
export { ForwardRef as ReactComponent };